var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 458.447,
    y2: 12.997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de932c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08841,
    stopColor: "#e6a236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24156,
    stopColor: "#f1b643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4169,
    stopColor: "#f9c44d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63166,
    stopColor: "#fecd52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcf54"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 459.447,
    y2: 11.997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe2a9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28938,
    stopColor: "#ffe09e",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65252,
    stopColor: "#ffd97f",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffcf54",
    stopOpacity: 0.5
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    gradientUnits: "userSpaceOnUse",
    x1: 140.775,
    x2: 223.546,
    y1: 145.813,
    y2: 145.813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2921,
    stopColor: "#363234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#282425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    gradientUnits: "userSpaceOnUse",
    x1: 311.654,
    x2: 394.425,
    y1: 145.813,
    y2: 145.813
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#464144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50651,
    stopColor: "#322e30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    gradientUnits: "userSpaceOnUse",
    x1: 46.666,
    x2: 260.403,
    y1: 386.8,
    y2: 386.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11647,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbfbfb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path70127",
    d: "m478.725 235.72182c0 123.0076-99.71739 222.725-222.72507 222.725-123.00761 0-222.725-99.71733-222.725-222.725s99.7174-222.72499 222.72507-222.72499 222.725 99.71745 222.725 222.72505z",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path70127-2",
    d: "m478.725 235.72182c0 123.0076-99.71739 222.725-222.72507 222.725-123.00761 0-222.725-99.71733-222.725-222.725s99.7174-222.72499 222.72507-222.72499 222.725 99.71745 222.725 222.72505z",
    fill: "none",
    stroke: "url(#linear-gradient-2)",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    "data-name": "path70127"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m307.71153 310.3269a93.57606 93.57606 0 0 1 -123.35712-42.27614",
    fill: "none",
    stroke: "#232122",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 22
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170.994,
    cy: 166.694,
    fill: "#fff",
    r: 72.703
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 341.006,
    cy: 166.694,
    fill: "#fff",
    r: 72.703
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.16,
    cy: 145.813,
    fill: "url(#linear-gradient-3)",
    r: 41.386
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.039,
    cy: 145.813,
    fill: "url(#linear-gradient-4)",
    r: 41.386
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m208.22 64.47044c-30.32362-15.373-76.18266-5.78959-95.21631 20.98315",
    fill: "none",
    stroke: "#232122",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 22
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m303.78006 33.14976c30.32373-15.37291 76.18256-5.78968 95.21631 20.98315",
    fill: "none",
    stroke: "#232122",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 22
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m258.89085 299.44311a18.73964 18.73964 0 0 0 -23.67458-10.23336l-117.97771 43.343a202.98136 202.98136 0 0 0 -3.79411-28.45414c-3.25229-15.98861-15.43345-29.84593-28.71222-33.36869-13.27832-3.523-23.7043 6.45046-23.162 15.93532.54183 9.48464 11.38148 20.05337 12.46558 53.92733.46343 14.48-12.46558 34.507-12.46558 34.507l.01351.02091a81.47923 81.47923 0 0 0 66.58281 128.47383c5.9671 0 26.23307-.39646 61.17631-13.00751a234.28859 234.28859 0 0 0 43.76537-21.544c7.75287-4.765 17.5803-12.28513 15.74575-25.67735l-.5719-1.69225a19.452 19.452 0 0 0 -23.7574-12.47636.94057.94057 0 0 1 -1.17208-.622.93744.93744 0 0 1 .4017-1.0648l5.19351-3.23987a18.58869 18.58869 0 0 0 10.05277-24.60078c-3.91489-9.06051-14.4265-13.288-23.72419-9.97556l-3.36756 1.19975a1.17618 1.17618 0 0 1 -1.46736-.6254 1.17618 1.17618 0 0 1 .51717-1.51933l5.08368-2.72365a19.67825 19.67825 0 0 0 10.78652-26.18685v-.00022a19.67781 19.67781 0 0 0 -25.22951-10.42326l-9.07558 3.56915a1.03087 1.03087 0 0 1 -1.29939-.49845 1.03086 1.03086 0 0 1 .48219-1.39319l57.51807-27.14068a18.73948 18.73948 0 0 0 9.66623-24.50859z",
    fill: "url(#linear-gradient-5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji0);
export default __webpack_public_path__ + "static/media/emoji_0.44eb371768b0ecd325aa62f87c2ab44d.svg";
export { ForwardRef as ReactComponent };